import React from 'react';
import {
  Box, Typography,
} from 'vindi-ds-components';
import ListProducts from '../../list_products';

const MeasurementUnit = () => (
  <Box display='flex' flexDirection='column' width='50%' mb='2em'>
    <Typography variant='subtitle2' component='h3' style={{ marginBottom: '1em' }}>Medida</Typography>
    <ListProducts />
    <Typography variant='caption' component='h4' style={{ marginTop: '1em' }}>Define a medida do produto vendido</Typography>
  </Box>
);

export default MeasurementUnit;
